import axios from 'axios'
import { Toast } from 'mint-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  transformRequest: [function (data) {
    // Do whatever you want to transform the data
    let ret = ''
    for (const it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  withCredentials: true,
  timeout: 5000 // request timeout
})

service.interceptors.request.use((config)=>{
  if(config.url.indexOf('?') == -1){
    config.url = config.url + '?' + encodeURIComponent('random') + '=' + encodeURIComponent(new Date().getTime())
  } else {
    config.url = config.url + '&' + encodeURIComponent('random') + '=' + encodeURIComponent(new Date().getTime())
  }
  return config
}, ()=>{

})

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      if (parseInt(res.code) === 0) {
        Toast({
          message: res.msg,
          position: 'bottom',
          duration: 1000
        })
      } else if (parseInt(res.code) > 400) {
        return Promise.reject(res)
      }
      return Promise.reject(new Error(res.code || 'Error'))
    }
    return response
  },
  error => {
    console.log('err' + error) // for debug
    // Toast({
    //   message: error,
    //   position: 'bottom',
    //   duration: 1000
    // })
    return Promise.reject(error)
  }
)

export default service
